import { useLocation } from "react-router-dom";

export const OfferExpiredBanner = () => {
  const location = useLocation();

  if (
    !location.state?.expiredReferral ||
    !location.state.expiredReferral.isExpired
  ) {
    return <></>;
  }

  const bannerText =
    location.state.expiredReferral.code &&
    location.state.expiredReferral.code.includes("deal")
      ? "Thank you for your interest in the DeltaMath for Home Summer Deal. This deal has expired."
      : "Thank you for your interest in the DeltaMath for Home Summer Deal. This referral link has expired.";

  // Remove expired referral from state - prevents the banner from showing up again if the user refreshes the page
  window.history.replaceState({}, "");

  return (
    <div className="flex min-h-10 w-full items-center justify-center bg-dm-error-200 px-4 py-2 md:px-14 md:py-0">
      <p>{bannerText}</p>
    </div>
  );
};
